import styled from 'styled-components';
import { WIDGET_BASE_HEIGHT } from './utils/constants';

export const ExperienceDashboardWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const OverviewWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  overflow-x: hidden;
  padding-right: 10px;
`;

export const Panel = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  grid-auto-rows: ${WIDGET_BASE_HEIGHT}px;
  gap: 10px;
`;
